<template>
  <v-card
    class="commission-agreement-nets"
  >
    <v-card-text>
      <div class="py-3">
        <h1 class="text-h5">
          Toimeksiantosopimus
        </h1>
        <p class="mt-4 mb-0">
          Sinun tulee tunnistautua pankkitunnuksillasi, jotta voit tarkastella
          toimeksiantosopimusta ja allekirjoittaa sen sähköisesti. Käytämme NETSin tarjoamaa
          tunnistautumista, jotta voimme varmistua henkilöllisyydestäsi.
        </p>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn
        text
        color="primary"
        @click="netsLink()"
      >
        Tunnistaudu
        <v-icon>
          chevron_right
        </v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
// import moment from 'moment';
import { mapState } from 'vuex';
import { apiPost } from '../api';

export default {
  computed: {
    ...mapState({
      commissionAgreements: state => state.commissionAgreement.byId,
    }),
    pid() {
      if (this.commissionAgreements && this.commissionAgreements[this.id]) {
        return this.commissionAgreements[this.id].person;
      }
      if (this.commissionAgreements && this.commissionAgreements[`${this.id}`]) {
        return this.commissionAgreements[`${this.id}`].person;
      }
      return null;
    },
    id() {
      return this.$route.params.id;
    },
  },
  methods: {
    async netsLink() {
      let side = '';

      if (this.$route.params.side) {
        side = `_${this.$route.params.side}`;
      }

      const state = `agreement_${this.$route.params.id}_${this.$route.params.companyId}_${this.pid}${side}`;

      const response = await apiPost('nets/get-link', { state });

      if (this.pid) {
        window.location.href = response.result;
      }
    },
  },
};
</script>
<style lang="scss">
.commission-agreement-nets {
  max-width: 600px;
  margin-left: auto;
  margin-right:auto;
}
</style>
